import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

const STATIC_VOICES = [
  { id: '21m00Tcm4TlvDq8ikWAM', name: 'Rachel (US Female)' },
  { id: 'ErXwobaYiN019PkySvjV', name: 'Antoni (US Male)' },
  { id: 'AZnzlk1XvdvUeBnXmlld', name: 'Domi (US Female)' },
  { id: 'EXAVITQu4vr4xnSDxMaL', name: 'Bella (US Female)' },
  { id: 'MF3mGyEYCl7XYWbV9V6O', name: 'Elli (US Female)' },
  { id: 'TxGEqnHWrfWFTfGW9XjX', name: 'Josh (US Male)' },
  { id: 'VR6AewLTigWG4xSOukaG', name: 'Arnold (US Male)' },
  { id: 'pNInz6obpgDQGcFmaJgB', name: 'Adam (US Male)' },
  { id: 'yoZ06aMxZJJ28mfd3POQ', name: 'Sam (US Male)' }
];

function App() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedVoice, setSelectedVoice] = useState(STATIC_VOICES[0].id);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      setSelectedFile(file);
      setError('');
    } else {
      setError('Please select a valid video file');
    }
  };

  const handleVoiceChange = (event) => {
    setSelectedVoice(event.target.value);
  };

  const handleConvert = async () => {
    if (!selectedFile) {
      setError('Please select a video file');
      return;
    }

    setIsProcessing(true);
    setError('');
    setProgress('Uploading video...');

    const formData = new FormData();
    formData.append('input_video', selectedFile);

    try {
      setProgress('Converting voice...');
      const response = await axios.post(
        `https://lingo-bingo-api.prakashsoftwares.com/convert_and_mark?voice_id=${selectedVoice}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          responseType: 'blob'
        }
      );

      setProgress('Preparing download...');
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `converted_${selectedFile.name}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setProgress('Download completed!');
    } catch (err) {
      setError('Conversion failed. Please try again.');
      setProgress('');
    } finally {
      setIsProcessing(false);
      setTimeout(() => setProgress(''), 3000);
    }
  };

  return (
    <div className="app">
      <div className="container">
        <h1>Video Accent Converter</h1>
        <p className="subtitle">Convert your video's voice to different accents</p>
        
        <div className="upload-section">
          <label htmlFor="video-upload" className="upload-label">
            📹 Select Video File
          </label>
          <input
            id="video-upload"
            type="file"
            accept="video/*"
            onChange={handleFileChange}
            className="file-input"
          />
          {selectedFile && (
            <div className="file-info">
              <span className="file-name">✅ {selectedFile.name}</span>
              <span className="file-size">({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)</span>
            </div>
          )}
        </div>

        <div className="voice-section">
          <label htmlFor="voice-select" className="voice-label">
            🎤 Select Target Voice
          </label>
          <select
            id="voice-select"
            value={selectedVoice}
            onChange={handleVoiceChange}
            className="voice-select"
          >
            {STATIC_VOICES.map((voice) => (
              <option key={voice.id} value={voice.id}>
                {voice.name}
              </option>
            ))}
          </select>
        </div>

        {error && <div className="error">❌ {error}</div>}
        {progress && <div className="progress">⏳ {progress}</div>}

        <button
          onClick={handleConvert}
          disabled={!selectedFile || isProcessing}
          className="convert-button"
        >
          {isProcessing ? '🔄 Converting...' : '🚀 Convert & Download'}
        </button>

        <div className="info-section">
          <h3>How it works:</h3>
          <ol>
            <li>Upload your video file</li>
            <li>Select the target voice accent</li>
            <li>Click convert to process the video</li>
            <li>Download the converted video automatically</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default App;
